import { Application } from "@hotwired/stimulus"

// Reuse global Stimulus app if it already exists (e.g., when admin bundle also runs Stimulus)
const application = window.Stimulus || Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
